import classNames from 'classnames'
import React from 'react'

import { Card } from '../../card/card.js'

export type RadioCardInputAttributes = Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'checked' | 'defaultChecked' | 'onChange' | 'disabled' | 'value'
>

export interface RadioCardProps {
    id: string
    labelText: string
    value?: string
    input?: RadioCardInputAttributes
    checked?: boolean
    description?: string
    hiddenIndicator?: boolean
    isDisabled?: boolean
    isInvalid?: boolean
    className?: string
    onChange?: (checked: boolean) => void
}

export const RadioCard = (props: RadioCardProps): JSX.Element => {
    const { checked, description, hiddenIndicator, isDisabled, id, input, isInvalid, labelText, value = 'on' } = props

    const inputRef: React.RefObject<HTMLInputElement> = React.createRef<HTMLInputElement>()

    const className: string = classNames(
        'radio-card',
        hiddenIndicator && 'radio-card--hidden-indicator',
        props.className,
    )

    const onChange = (): void => {
        if (inputRef.current) {
            if (isDisabled || checked) {
                return
            }

            if (props.onChange) {
                props.onChange(true)
            }
        }
    }

    return (
        <div className={className} onClick={() => onChange()}>
            <Card
                className="radio-card__body"
                hasContent={true}
                padding="small"
                variant={checked ? 'secondary' : undefined}
            >
                <input
                    {...input}
                    value={value}
                    type="radio"
                    ref={inputRef}
                    onChange={onChange}
                    checked={checked}
                    defaultChecked={undefined}
                    disabled={isDisabled}
                    id={id}
                    className="radio-card__input"
                    aria-invalid={isInvalid}
                />
                <span className="radio-card__inner">
                    <label htmlFor={id} className="radio-card__label">
                        <p className="radio-card__text bold">{labelText}</p>
                        {description && <p className="radio-card__description">{description}</p>}
                    </label>
                    {!hiddenIndicator && <span className="radio-card__indicator" />}
                </span>
            </Card>
        </div>
    )
}
